export default __webpack_public_path__ + "static/media/concrete-ramp.cb9cceb6.jpg";